import { Injectable, InjectionToken } from '@angular/core';
import { Converter } from '@spartacus/core';
import { TrackingDelivery, TrackingDeliveryApi } from '@tracking/const';

@Injectable({ providedIn: 'root' })
export class TmsTrackingApiNormalizer implements Converter<TrackingDeliveryApi, TrackingDelivery> {
  convert(source: TrackingDeliveryApi, target?: TrackingDelivery): TrackingDelivery {
    if (target === undefined) {
      target = {
        ...(source as any),
      };
    }

    if (target) {
      target.plannedDeliveryFrom = new Date(source.plannedDeliveryFrom);
      target.plannedDeliveryTo = new Date(source.plannedDeliveryTo);
      target.statuses = source.statuses.map((status) => ({
        ...status,
        datetimeAt: status.datetimeAt ? new Date(status.datetimeAt) : null,
      }));
    }

    return target;
  }
}

export const TMS_TRACKING_API_NORMALIZER = new InjectionToken<TmsTrackingApiNormalizer>('TmsTrackingApiNormalizer');
